import React from 'react';

import Box from '@material-ui/core/Box'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import withWidth from '@material-ui/core/withWidth';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import SearchIcon from '@material-ui/icons/Search';
import Collapse from '@material-ui/core/Collapse';
//import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import FreeBreakfastIcon from '@material-ui/icons/FreeBreakfast';
//import RestaurantIcon from '@material-ui/icons/Restaurant';
//import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';

import { useIklan } from './useIklan';
import { withFirebase } from '../../components/Firebase';
import useAuthUser from '../../hooks/useAuthUser';
import { ListMiniIklan, DialogSearchIklan,DialogNewAds,DialogShowAds } from '.';
import { read, write } from '../../utils/localStorageUtils';

const IklanBoxDefaultMode="banner-bottom"

const IklanBox=React.memo((props)=>{
  const {
    width,
    firebase,
  }=props

  const {
    adsMode, 
    setAdsMode,
  }=useIklan()

  const authUser=useAuthUser(firebase)
  const [hasAuthUser,setHasAuthUser]=React.useState(false)

  React.useEffect(()=>{
    setHasAuthUser(!!authUser)
  },[authUser])
  React.useEffect(()=>{
    setAdsMode(hasAuthUser?IklanBoxDefaultMode:"minimize")
  },[hasAuthUser])

  const startVisibleDocRef=React.useRef()
  const lastVisibleDocRef=React.useRef()
  const [searchText,setSearchText]=React.useState("")
  const [pageMethode,setPageMethode]=React.useState("startAt")
  const [pageCount,setPageCount]=React.useState(0)

  const adsRefreshInterval=30000
  const adsCountdownRef=React.useRef()
  const adsRefreshCountdownRef=React.useRef(adsRefreshInterval)
  

  const [adsList,setAdsList]=React.useState([])
  const [adsToPreview,setAdsToPreview]=React.useState()
  const [adsToShow,setAdsToShow]=React.useState([])

  const [openSearchIklanDialog,setOpenSearchIklanDialog]=React.useState(false)
  const [openNewAds,setOpenNewAds]=React.useState()

  
  const onChangeSearchText=React.useCallback((search)=>{
    setPageCount(0)
    setSearchText(search)
    setPageMethode("startAt")
    if(!!search){
      let str=read("cariiklan.search.history","",true)
      let arr=str.split("|")
      if(!str){
        arr=[]
      }
      arr.unshift(search)
      arr=arr.slice(0,5)
      arr=Array.from(new Set(arr))
      write("cariiklan.search.history",arr.join("|"),true)
    }
  },[])
  
  const handlePageBack=React.useCallback(()=>{
    setPageMethode("endBefore")
    setPageCount(prev=>prev-1)
    adsRefreshCountdownRef.current=adsRefreshInterval
    console.log("back")
  },[])
  const handlePageNext=React.useCallback(()=>{
    setPageMethode("startAfter")
    setPageCount(prev=>prev+1)
    adsRefreshCountdownRef.current=adsRefreshInterval
    console.log("next")
  },[])
  
  const [showOnForeground,setShowOnForeground]=React.useState(true)
  React.useEffect(()=>{
    var hidden, visibilityChange;
    if (typeof document.hidden !== "undefined") {
      hidden = "hidden";
      visibilityChange = "visibilitychange";
    } else if (typeof document.mozHidden !== "undefined") {
      hidden = "mozHidden";
      visibilityChange = "mozvisibilitychange";
    } else if (typeof document.msHidden !== "undefined") {
      hidden = "msHidden";
      visibilityChange = "msvisibilitychange";
    } else if (typeof document.webkitHidden !== "undefined") {
      hidden = "webkitHidden";
      visibilityChange = "webkitvisibilitychange";
    } else {
      setShowOnForeground(false)
      return
    }
    let listener=()=>{
      let isForeground=window.document[hidden] ? false : true
      //console.log("state foreground = "+isForeground)
      setShowOnForeground(isForeground)
    }

    window.document.addEventListener(visibilityChange, listener, false);
    return ()=>{
      window.document.removeEventListener(visibilityChange,listener)
    }
  },[])
  /* const timerNext=React.useRef()
  React.useEffect(()=>{
    timerNext.current=window.setInterval(()=>{
      //console.log(adsMode)
      if(showOnForeground&&skipAdsCount>=0&&adsMode!=="minimize"&&!adsToPreview){
        //handlePageNext()
        setPageMethode("startAfter")
        setPageCount(prev=>prev+1)
        console.log("next")
      }
    },300000)
    return ()=>{
      console.log("clear next ads")
      window.clearInterval(timerNext.current)
    }

  },[adsMode,adsToPreview,showOnForeground,skipAdsCount]) */

  
  React.useEffect(()=>{
    adsCountdownRef.current=window.setInterval(()=>{
      //console.log("count Next "+adsRefreshCountdownRef.current)
      if(showOnForeground&&!openSearchIklanDialog&&!openNewAds&&adsMode!=="minimize"&&!adsToPreview){
        adsRefreshCountdownRef.current-=1000
      }
      if(adsRefreshCountdownRef.current<=0){
        adsRefreshCountdownRef.current=adsRefreshInterval
        setPageMethode("startAfter")
        setPageCount(prev=>prev+1)
        console.log("Do Next")
      }
    },1000)
    return ()=>{
      //console.log("clear next ads")
      window.clearInterval(adsCountdownRef.current)
    }
  },[adsMode,adsToPreview,showOnForeground,openSearchIklanDialog,openNewAds])
  
  let screenWidth=/* window.screen.width */  window.innerWidth - 100
  const adsWidth=80
  const spaceWidth=2
  let adsLimitPerPage=React.useMemo(()=>openSearchIklanDialog?10:parseInt(screenWidth/(adsWidth+spaceWidth)) 
  ,[screenWidth,adsWidth,spaceWidth,openSearchIklanDialog])
  

  React.useEffect(()=>{
    if(!firebase&&pageCount>=0)return
    //console.log(" Cari Iklan ",adsLimitPerPage,pageMethode,startVisibleDocRef.current?.data().name,lastVisibleDocRef.current?.data().name)
    let query
    if(!!searchText){
      query=firebase.fs.collection("apps/CariIklan/live-ads").where("keywords", "array-contains", searchText)
      query=query.orderBy("pricePerView","desc")
      query=query.orderBy("purchaseDate","asc")
      switch(pageMethode){
        case "startAfter" ://next
          if(!!lastVisibleDocRef.current) query=query.startAfter(lastVisibleDocRef.current)
          break
        case "endBefore" ://back
          if(!!startVisibleDocRef.current) query=query.endBefore(startVisibleDocRef.current)
          break
        default :
      }
    }else{
      query=firebase.fs.collection("apps/CariIklan/live-ads")
      query=query.orderBy("pricePerView","desc")
      query=query.orderBy("purchaseDate","asc")
      switch(pageMethode){
        case "startAfter" ://next
          if(!!lastVisibleDocRef.current) query=query.startAfter(lastVisibleDocRef.current)
          break
        case "endBefore" ://back
        if(!!startVisibleDocRef.current) query=query.endBefore(startVisibleDocRef.current)
          break
        default :
      }
    }
    
    query=query.limit(adsLimitPerPage)

    return query.onSnapshot((querySnapshot) => {
        var liveAds = [];
        querySnapshot.forEach((doc) => {
            liveAds.push(doc.data());
        });
        setAdsList(liveAds)

        var firstVisible = querySnapshot.docs[0]
        startVisibleDocRef.current=firstVisible

        var lastVisible = querySnapshot.docs[querySnapshot.docs.length-1]
        lastVisibleDocRef.current=lastVisible
        
    });
  },[firebase,searchText,adsLimitPerPage,pageMethode,pageCount])
  
  const handleClickTutup=React.useCallback(()=>{
    if(adsMode==="minimize"){
      setAdsMode("banner-bottom")
    }else{
      setAdsMode("minimize")
    }
  },[adsMode,setAdsMode])

  React.useEffect(()=>{
    if(adsList.length >= adsLimitPerPage){
      //ads kebanyakan trim
      let newArr=[]
      for(let i=0;i<adsList.length;i++){
        if(i<adsLimitPerPage){
          newArr.push(adsList[i])
        }
      }
      setAdsToShow(newArr)
    }else{
      //add 1 null
      let newArr=[...adsList]
      newArr.push(null)
      setAdsToShow(newArr)
    }
  },[adsLimitPerPage,adsList])

  
  const handleClickAds=React.useCallback((ads)=>{
    setAdsToPreview(ads)
  },[])
  const handleCloseAds=React.useCallback((ads)=>{
    setAdsToPreview(null)
  },[])

  const handleOpenDialogSearchIklan=React.useCallback(()=>{
    setOpenSearchIklanDialog(true)
  },[])

  const handleCloseDialogSearchIklan=React.useCallback(()=>{
    setOpenSearchIklanDialog(false)
  },[])

  const handleClickNew=React.useCallback(()=>{
    if(!hasAuthUser){
      window.open("https://cari-iklan.web.app")
      return
    }
    handleCloseDialogSearchIklan()
    setOpenNewAds(true)
  },[hasAuthUser,handleCloseDialogSearchIklan])

  const handleCloseNewAds=React.useCallback(()=>{
    setOpenNewAds(null)
  },[])

  return (

    <Box
      style={{
        position:"fixed",
        bottom:"0px",
        left:"0px",
        width:"100vw",
        height:adsMode==="minimize"?"14px":"85px",
        transition: "height 0.5s",
        padding:"2px",
        backgroundColor:width==="xs"?"black":"white",
        borderTop:width==="xs"?"1px solid white":"1px solid black",
      }}
    >

      <Collapse
        in={adsMode!=="minimize"}
        timeout={500}
      >
        <Box
          style={{
            display:"flex",
            justifyContent: "center",
          }}
        >
          <Box
            style={{
              alignSelf: "center",
              flexBasis:"40px",
            }}
          >
            <IconButton
              onClick={handlePageBack}
              disabled={pageCount<=0}
              color="inherit"
            >
              <ChevronLeftIcon style={{color:"#dddddd",opacity:pageCount<=0?0.5:1,fontSize:"35px"}}/>
            </IconButton>
          </Box>
 
          <Box
            style={{
              flexGrow:1,
              alignSelf: "center",
              textAlign:"center",
              height:"80px"
            }}
          >
            <Box
              style={{
                overflowX:"auto",
                overflowY:"hidden",
                whiteSpace: "nowrap",
                display:"inline-block",
                maxWidth:"100vw",
              }}
            >
              <ListMiniIklan
                listAds={adsToShow}
                light={width==="xs"}
                onClickAds={handleClickAds}
                onClickNew={handleClickNew}
              />
            </Box>
          </Box>
          <Box
            style={{
              alignSelf: "center",
              flexBasis:"40px",
            }}
          >
            <IconButton
              onClick={handlePageNext}
              disabled={adsList<adsLimitPerPage}
              color="inherit"
            >
              <ChevronRightIcon style={{color:"#dddddd",opacity:adsList<adsLimitPerPage?0.5:1,fontSize:"35px"}}/>
            </IconButton>
          </Box>
        </Box>
      </Collapse>

      <Box
        style={{
          position:"absolute",
          top:0,
          left:0,
          padding:"0px 4px",
          backgroundColor:"grey",
          color:"white",
          fontSize:"12px",
          cursor:"pointer",
        }}
        tabIndex={0}
        onKeyDown={()=>{}}
        onClick={handleOpenDialogSearchIklan}
      >
        <SearchIcon style={{color:"white",fontSize:"12px",}}/> Iklan
        
      </Box>
      <Box
        style={{
          position:"absolute",
          top:0,
          right:0,
          padding:"0px 4px",
          backgroundColor:"grey",
          color:"white",
          fontSize:"12px",
          cursor:"pointer",
        }}
        tabIndex={0}
        onKeyDown={handleClickTutup}
        onClick={handleClickTutup}
      >
        {adsMode==="minimize"?"Lihat":"Tutup"} {adsMode==="minimize"?<FreeBreakfastIcon style={{color:"white",fontSize:"12px",}}/>:<CloseIcon style={{color:"white",fontSize:"12px",}}/>}
      </Box>
      
      <DialogSearchIklan
        open={openSearchIklanDialog}
        onClose={handleCloseDialogSearchIklan}
        onItemClick={handleClickAds}
        onClickNew={handleClickNew}
        isMobile={width==="xs"}
        adsList={adsList}
        searchText={searchText}
        onChangeSearchText={onChangeSearchText}
      />

      <DialogShowAds
        adsToPreview={adsToPreview}
        handleCloseAds={handleCloseAds}
      />

      <DialogNewAds
        open={openNewAds}
        onClose={handleCloseNewAds}
        firebase={firebase}
        //currentUser={currentUser}
        authUser={authUser}
        isMobile={width==="xs"}
      />


      
    </Box>
  )
})








export default withWidth()(withFirebase(IklanBox))